export const getServerSideProps = async context => {
  if (!context.req.user) {
    if (context.req.session) {
      context.req.session.returnTo = context.req.originalUrl;
    }
    return {
      props: {},
    };
  }

  const ip =
    context.req.headers['x-forwarded-for'] ||
    context.req.socket.remoteAddress ||
    context.req.connection.remoteAddress;

  return {
    props: { ip },
  };
};

export const getInitialProps = async context => {
  if (context && context.req) {
    if (!context.req.user) {
      if (context.req.session) {
        context.req.session.returnTo = context.req.originalUrl;
      }
    }
  }
  return {
    props: {},
  };
};
